import { StorageManager } from '../../../common/storage-manager.class';
import { environment } from '../../../../environments/environment';

export class ClientesEnvironmentDefinition {
  public clienteName = environment.features.clienteName;

  public appName = environment.appName;

  public applicationType = environment.features.applicationType;

  public serverUrl = environment.serverUrl;

  public showTecnicoAsignado = (this.appName !== 'melia' && this.appName !== 'gardengest' && this.appName !== 'covidai');

  public hasCodigoCliente = environment.features.hasCodigoCliente;

  public showClientesFirma = environment.features.showClientesFirma;

  public showClientesObservaciones = environment.features.showClientesObservaciones;

  public showClientesNotas = environment.features.showClientesNotas;

  public showClientesCooperativa = environment.features.showClientesCooperativa;

  public showClientesRegepa = environment.features.showClientesRegepa;

  public showClientesCsv = environment.features.showClientesCsv;

  public showReto = environment.features.showReto;

  public showCrm = environment.features.showCrm;

  public showRopoRomaRegepa = environment.features.showRopoRomaRegepa;

  public hasClientesAliasField = environment.features.hasClientesAliasField;

  public showFieldsClientesEstadoReglas = environment.features.showFieldsClientesEstadoReglas;

  public showCuadernoDeCampoPorCliente = environment.features.showCuadernoDeCampoPorCliente;

  public showFincasLibroFertilizantes = environment.features.showFincasLibroFertilizantes;

  public showFincasInformeTratamientos = environment.features.showFincasInformeTratamientos;

  public showMostrarTodosClientes = environment.features.showMostrarTodosClientes;

  public clientesMostrarTodosDefault = environment.features.clientesMostrarTodosDefault;

  public canAddClients = environment.features.canAddClients;

  public showAllClients = this.clientesMostrarTodosDefault;

  public showClientesTecnico = environment.features.showClientesTecnico;

  public showSdiClientes = environment.features.showSdiClientes;

  public clientesName = environment.features.clientesName;

  public rol: string = StorageManager.getUser().rol;

  public canEditClients = this.rol !== 'responsable' && environment.features.canEditClients;

  public canDeleteClients = this.rol !== 'responsable' && environment.features.canDeleteClients;

  public activateREA = environment.features.activateREA;
}// class;